import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    excludeIngredients: '',
    diet: '',
    type: '',
    maxReadyTime: '',
    minCalories: '',
    maxCalories: '',
    minCarbs: '',
    maxCarbs: '',
    minProtein: '',
    maxProtein: '',
    minFat: '',
    maxFat: '',
    minSaturatedFat: '',
    maxSaturatedFat: '',
    minFiber: '',
    maxFiber: '',
  },
  pagination: {
    pageSize: 20,
    page: 1,
  },
};

export const recipesSearchFiltersSlice = createSlice({
  name: 'recipesSearchFilters',
  initialState,
  reducers: {
    setRecipesSearchFiltersPage: (state, action) => {
      state.pagination.page = action.payload;
    },
    setRecipesSearchFilters: (state, action) => {
      state.filters = action.payload;
    },
    updateRecipesSearchFiltersState: (state, { payload: { filters, pagination } }) => {
      state.filters = filters;
      state.pagination = pagination;
    },
  },
  selectors: {
    selectRecipesSearchFiltersPagination: ({ pagination }) => pagination,
    selectRecipesSearchFilters: ({ filters }) => filters,
  },
});

export const { setRecipesSearchFiltersPage, setRecipesSearchFilters, updateRecipesSearchFiltersState } =
  recipesSearchFiltersSlice.actions;
export const { selectRecipesSearchFiltersPagination, selectRecipesSearchFilters } = recipesSearchFiltersSlice.selectors;
export default recipesSearchFiltersSlice.reducer;
